import { groupTitleValue } from '@/components/FormBuilder/Item.utils';

export const nonFormFieldTypes: Array<string> = [groupTitleValue];

export const ErrorTypes = {
  formFieldRequired: 'formFieldRequired',
} as const;
